export default __webpack_public_path__ + "static/media/102_mobile.477eb35d.jpg";